export const UPDATE_TOKEN = 'UPDATE_TOKEN'

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'

export const UPDATE_PERMISSIONS_LIST = 'UPDATE_PERMISSIONS_LIST'

/**
 * 当前用户的权限列表
 */
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'

/**
 * 获取任务类型和业务类型下拉列表数据
 */
export const UPDATE_BUSINESSTYPE = 'UPDATE_BUSINESSTYPE'
export const UPDATE_TASKTYPE = 'UPDATE_TASKTYPE'
